type AppNames = {
  [pathname: string]: string
}

const appNames: AppNames = Object.freeze({
  '/card/lookup/informed-delivery': 'Informed Delivery',
  '/card/mail': 'Mail Lander',
  '/creditkarma/welcome': 'CKEA Flow',
  '/directmail/lookup': 'Direct Mail Lookup',
  '/flow/alt-offer': 'Counter Offer Flow',
  '/flow/app-download': 'App Download',
  '/flow/application': 'Single Page',
  '/flow/bank/oauth': 'CFU Flow',
  '/flow/decisioned': 'App Flow Decisioned',
  '/flow/decisioning': 'Decisioning',
  '/flow/id-confirmation': 'IDology',
  '/flow/id-conflict': 'App Flow ID Conflict',
  '/flow/id-verification': 'Identity Verification',
  '/flow/in-review': 'Review App',
  '/flow/frozen': 'Frozen Bureau Flow',
  '/flow/proof-of-income': 'POI Flow',
  '/flow/secured-card-funding': 'Secured Card Funding',
  '/lookup': 'App Lookup',
  '/maintenance': 'Maintenance',
  '/prequalification': 'Prequal',
  '/prequalification/alt-offer': 'Prequal Counter Offer Flow',
  '/prequalification/bank-login/oauth': 'Prequal CFU Flow',
  '/prequalification/decisioned': 'Prequal Decisioned',
  '/prequalification/decisioning': 'Prequal Decisioning',
  '/prequalification/frozen': 'Prequal',
  '/prequalification/id-conflict': 'Prequal ID Conflict',
  '/prequalification/id-verification': 'Prequal Identity Verification',
  '/prequalification/in-review': 'Review Prequal',
})

export default appNames
